var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "10 5 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#D31145"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.189 33.9882C30.1228 34.1257 30.1154 34.2798 30.1669 34.4233C30.2184 34.5668 30.3234 34.6812 30.4752 34.752C31.5476 35.2314 32.6889 35.482 33.871 35.4979H33.9926C35.2088 35.4979 36.3876 35.2466 37.4894 34.7546C37.7816 34.6323 37.9187 34.2977 37.7876 33.9928C37.6559 33.7012 37.3096 33.5702 37.0013 33.7058L36.9993 33.7071C35.0784 34.5609 32.8754 34.5609 30.9572 33.7078C30.667 33.5782 30.322 33.7045 30.189 33.9882ZM36.3876 29.0892C36.3876 28.5278 36.8489 28.0708 37.4172 28.0708C37.9848 28.0708 38.4468 28.5278 38.4468 29.0892C38.4468 29.6507 37.9848 30.1076 37.4172 30.1076C36.8489 30.1076 36.3876 29.6507 36.3876 29.0892ZM37.4172 31.257C38.6254 31.257 39.6082 30.2842 39.6082 29.0886C39.6049 27.8969 38.622 26.9248 37.4179 26.9215H37.4172C36.2084 26.9215 35.2249 27.8936 35.2249 29.0892C35.2249 30.2842 36.2084 31.257 37.4172 31.257ZM29.503 28.9477C29.5725 28.4531 30.0038 28.0708 30.5226 28.0708C31.0909 28.0708 31.5523 28.5278 31.5523 29.0892C31.5523 29.6507 31.0909 30.1076 30.526 30.1076C29.9643 30.101 29.5057 29.6434 29.5037 29.0879L29.503 28.9477ZM30.5226 31.257C31.7308 31.257 32.7156 30.2842 32.719 29.0899C32.7223 27.8916 31.7388 26.9149 30.5286 26.9116H30.5233C29.9383 26.9116 29.388 27.1357 28.9735 27.5438C28.5576 27.9531 28.3276 28.498 28.3263 29.0786C28.3243 29.6586 28.5516 30.2048 28.9655 30.6162C29.3786 31.0275 29.9296 31.255 30.5226 31.257ZM24.3628 30.4257V34.3076C23.6708 33.9121 23.2215 33.1715 23.2142 32.366C23.2142 31.5559 23.6641 30.8152 24.3628 30.4257ZM27.8957 23.7763H40.0381C41.3512 23.779 42.4217 24.8384 42.4243 26.1372L42.4444 35.7988C42.4417 37.0976 41.372 38.1564 40.0588 38.159H27.8957C26.5799 38.159 25.5075 37.1003 25.5048 35.7988V26.1365C25.5075 24.8351 26.5799 23.7763 27.8957 23.7763ZM33.552 20.614V20.6087C33.552 20.3719 33.7473 20.1788 33.988 20.1788C34.2273 20.1788 34.4226 20.3719 34.4226 20.6093C34.4226 20.8447 34.2287 21.0379 33.9906 21.0392H33.9873C33.8723 21.0392 33.764 20.9955 33.6824 20.9155C33.5995 20.8348 33.5527 20.727 33.552 20.614ZM44.7236 33.0524C44.5391 33.6165 44.1333 34.0814 43.6064 34.3479V30.3847C44.0276 30.5957 44.3693 30.9316 44.5879 31.3555C44.8607 31.8846 44.9095 32.4877 44.7236 33.0524ZM43.6064 29.164V26.1358C43.6044 24.2048 42.0125 22.6303 40.0588 22.627H34.5683V22.051C35.3071 21.7659 35.7357 20.9717 35.5358 20.1914C35.3198 19.3476 34.448 18.8357 33.5962 19.048C33.1823 19.1512 32.834 19.4077 32.616 19.7701C32.3974 20.1325 32.3345 20.5577 32.4395 20.9664C32.5665 21.4651 32.9296 21.8665 33.407 22.051V22.627H27.8957C25.9407 22.627 24.3461 24.2015 24.3428 26.1365V29.1765C23.5465 29.4344 22.8819 29.9661 22.46 30.6896C22.004 31.4679 21.8817 32.3759 22.117 33.2449C22.4132 34.3446 23.2576 35.2228 24.3428 35.576V35.8153C24.3548 37.7411 25.9487 39.3077 27.8957 39.3077H40.0394C41.9911 39.305 43.583 37.7311 43.5864 35.7988V35.5859C45.0118 35.154 45.9947 33.8579 46 32.3673V32.3653C45.992 30.8886 45.0172 29.5991 43.6064 29.164Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_108_3423",
    x: 0,
    y: 0,
    width: 68,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_108_3423"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_108_3423",
    result: "effect2_dropShadow_108_3423"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_108_3423",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.ce06fa144a565a9d02fb2d1ac7215a9d.svg";
export { ForwardRef as ReactComponent };